<div class="wrapper sidebar-lg">
   <div class="app-sidebar" data-active-color="white" data-background-color="black" data-image="">
        <app-sidebar></app-sidebar>
        <div class="sidebar-background"></div>
    </div>
    <app-navbar></app-navbar>
    <div style="margin-left: 309px; margin-right:29px; margin-bottom: 10px;" *ngIf="progressPercent > 0 && progressPercent < 100">
        <label>({{progressCurrent}} / {{progressTotal}}) {{progressPercent.toFixed(1)}}% - {{progressTitle.substr(0, 30)}}</label>
        <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [attr.aria-valuenow]="progressCurrent" aria-valuemin="0" [attr.aria-valuemax]="progressTotal" [style.width.%]="progressPercent.toFixed(1)"></div>
        </div>
    </div>
    <div *ngIf="currentUser && currentUser.isAdmin && progressLink" style="margin-left: 309px; margin-right:29px; margin-bottom: 10px;"><a href="/{{progressLink}}" target="_blank">{{progressLinkTitle}}</a></div>
    <div class="main-panel">    
        <div class="main-content">
            <div class="content-wrapper">
                <div class="container-fluid">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <footer>
            <div class="container-fluid">
                <p class="copyright text-center">
                    &copy; {{currentDate | date: 'yyyy'}} <a>SCHOOL APP v{{version}}</a><span *ngIf="build"> &middot; {{build.tag}}<span *ngIf="build.number"> &middot; Build {{build.number}}</span><span *ngIf="build.builtAt"> vom {{build.builtAt | date: 'dd.MM.yyyy HH:mm'}}</span> &middot; gestartet {{build.startedAt | date: 'dd.MM.yyyy HH:mm'}}</span>
                </p>
            </div>
        </footer>
    </div>
</div>





// WEBPACK FOOTER //
// ./src/app/layouts/full/full-layout.component.html